var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcButtonFavouriteAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape 266",
    d: "M11.0004 18.6375L2.47744 9.86057C1.73013 9.1273 1.23566 8.17514 1.06567 7.14206C0.895676 6.10898 1.05898 5.04862 1.53193 4.11456C1.89656 3.40695 2.42243 2.79496 3.0671 2.32797C3.71177 1.86099 4.4572 1.55209 5.24322 1.42621C6.02924 1.30032 6.83383 1.36098 7.5921 1.60327C8.35036 1.84557 9.04106 2.2627 9.60844 2.82105L10.9999 4.09006L12.3914 2.82105C12.9588 2.2627 13.6495 1.84557 14.4078 1.60327C15.166 1.36098 15.9706 1.30032 16.7567 1.42621C17.5427 1.55209 18.2881 1.86099 18.9328 2.32797C19.5774 2.79496 20.1033 3.40695 20.4679 4.11456C20.9409 5.04862 21.1042 6.10898 20.9342 7.14206C20.7642 8.17514 20.2698 9.1273 19.5224 9.86057L11.0004 18.6375Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcButtonFavouriteAdd);
export default __webpack_public_path__ + "static/media/ic_button_favourite_add.59e75f82c5334363cd588efad1a40b16.svg";
export { ForwardRef as ReactComponent };